(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wann-info-page"]) return;
  try {
    
  function wannInfoTitle() {
    const info = document.querySelector('[data-wann-info]');
    if (!info) return;
    const handle = window.location.hash.slice(1);
    const panel = Array.from(info.querySelectorAll('.wann-info__panel')).find(item => item.id === handle) || info.querySelector('.wann-info__panel');
    const brand = info.querySelector('img').alt;
    document.title = panel.dataset.title + ' — ' + brand;
    panel.querySelector('h1').focus({ preventScroll: true });
    window.scrollTo(0, 0);
  }
  window.addEventListener('hashchange', wannInfoTitle);
  document.addEventListener('wann:languagechange', wannInfoTitle);
  wannInfoTitle();

  } catch(e) { console.error(e); }
})();
})();
